import { webApp } from '@shared'

export function useShouldShowDesktopStub(): boolean {
  const platform = webApp.platform ?? 'unknown'

   return platform !== 'ios' && platform !== 'android'
}
